import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
    ApprovalPolicy,
    CreateApprovalPolicy,
    EditApprovalPolicy,
    DepartmentApprovalPolicy,
    AssignDepartmentPolicy,
    ApprovalDelegate,
    CreateApprovalDelegate,
} from '../../models/approval/approval-policy.model';

@Injectable({
    providedIn: 'root',
})
export class ApprovalPolicyService {
    constructor(private http: HttpClient) {}

    // ── Policies ──────────────────────────────────────────────────────────────

    getPolicies(): Observable<{ policies: ApprovalPolicy[] }> {
        return this.http.get<{ policies: ApprovalPolicy[] }>(
            environment.approval.policies,
            { withCredentials: true }
        );
    }

    getPolicyByGuid(policyGuid: string): Observable<{ policy: ApprovalPolicy }> {
        return this.http.get<{ policy: ApprovalPolicy }>(
            `${environment.approval.policies}/${policyGuid}`,
            { withCredentials: true }
        );
    }

    createPolicy(payload: CreateApprovalPolicy): Observable<{ policy: ApprovalPolicy }> {
        return this.http.post<{ policy: ApprovalPolicy }>(
            environment.approval.policies,
            payload,
            { withCredentials: true }
        );
    }

    editPolicy(policyGuid: string, payload: EditApprovalPolicy): Observable<{ policy: ApprovalPolicy }> {
        return this.http.put<{ policy: ApprovalPolicy }>(
            `${environment.approval.policies}/${policyGuid}`,
            payload,
            { withCredentials: true }
        );
    }

    deletePolicy(policyGuid: string): Observable<void> {
        return this.http.delete<void>(
            `${environment.approval.policies}/${policyGuid}`,
            { withCredentials: true }
        );
    }

    // ── Department Policy Assignments ─────────────────────────────────────────

    getDepartmentPolicies(): Observable<{ items: DepartmentApprovalPolicy[] }> {
        return this.http.get<{ items: DepartmentApprovalPolicy[] }>(
            environment.approval.departmentPolicies,
            { withCredentials: true }
        );
    }

    assignDepartmentPolicy(payload: AssignDepartmentPolicy): Observable<void> {
        return this.http.put<void>(
            environment.approval.departmentPolicies,
            payload,
            { withCredentials: true }
        );
    }

    // ── Approval Delegates ────────────────────────────────────────────────────

    getDelegates(): Observable<{ delegates: ApprovalDelegate[] }> {
        return this.http.get<{ delegates: ApprovalDelegate[] }>(
            environment.approval.delegates,
            { withCredentials: true }
        );
    }

    createDelegate(payload: CreateApprovalDelegate): Observable<{ delegate: ApprovalDelegate }> {
        return this.http.post<{ delegate: ApprovalDelegate }>(
            environment.approval.delegates,
            payload,
            { withCredentials: true }
        );
    }

    deleteDelegate(delegateGuid: string): Observable<void> {
        return this.http.delete<void>(
            `${environment.approval.delegates}/${delegateGuid}`,
            { withCredentials: true }
        );
    }
}
